import apiClient from '../apiClient';

const API_URL = '/art/lesiones';

// Obtener todas las lesiones
export const getLesiones = async () => {
    const response = await apiClient.get(API_URL);
    return response.data;
};

// Obtener lesión por ID
export const getLesionPorId = async (id) => {
    const response = await apiClient.get(`${API_URL}/${id}`);
    return response.data;
};

// Crear lesión
export const crearLesion = async (data) => {
    const response = await apiClient.post(API_URL, data);
    return response.data;
};

// Actualizar lesión
export const actualizarLesion = async (id, data) => {
    const response = await apiClient.put(`${API_URL}/${id}`, data);
    return response.data;
};

// Eliminar lesión
export const eliminarLesion = async (id) => {
    const response = await apiClient.delete(`${API_URL}/${id}`);
    return response.data;
};

